import moment from "moment-timezone";
const handleValidTime = (time) => {
  const localTime = moment.utc(time).local();
  return localTime.format("HH:mm");
};

export default handleValidTime;
